Vue.component("MpModuleLogin", {
    props: {
        userLabel: String,
        passwdLabel: String,
        submitLabel: String,
        redirectUrl: String,
    },
    data: function() {
        return {
            FORM_URL: '/session/login',
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            VALIDATION_OK: 1,
            VALIDATION_KO: 0,

            user: '',
            passwd: '',

            errors: [],
            successMessage: '',
            errorMessage: loginFormError, // from jsVarCollection BusinessController.php
            validated: false,
        };
    },
    computed: {

        userCheck: function() {
            return !this.validated || !FormValidator.isEmpty(this.user);
        },

        passwdCheck: function() {
            return !this.validated || !FormValidator.isEmpty(this.passwd);
        }
    },
    methods: {

        cleanErrors: function() {
            this.errors = [];
        },

        addError: function(errorMsg) {
            if (this.errors.length > 0) {
                return;
            }

            this.errors.push(errorMsg);
        },

        validateForm: function() {
            /// error_data
            /// are globally injected from PHP controller
            var isValid = true;

            this.cleanErrors();
            this.validated = true;

            if (!this.userCheck || !this.passwdCheck) {
                this.addError(this.errorMessage);
                isValid = false;
            }

            return isValid;
        },

        resetForm: function() {
            this.user = '';
            this.passwd = '';

            this.validated = false;
            this.cleanErrors();
        },

        onSend: function(response) {
            if (response.status === 200 && response.data.result === 'OK') {
                window.location.href = (this.redirectUrl) ? this.redirectUrl : '/';
            } else {
                this.addError(response.data.message);
            }
        },

        sendForm: function(ev) {

            if (this.validateForm()) {
                axios
                    .post(this.FORM_URL, Serializer.serialize({
                        'login_user': this.user,
                        'login_passwd': this.passwd
                    }), {headers: { 'X-Requested-With': 'XMLHttpRequest' }})
                    .then(this.onSend)
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        },

        init: function() {
            if (this.isInitialized) {
                return;
            }

            this.isInitialized = true;
        },
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <form class="form u-mt-l" name="fmp_login" id="fmp_login" enctype="application/x-www-form-urlencoded" method="post">\
\
        <div class="row">\
            <div class="col-12 col-md-6">\
                <div class="form__group form__group--rm-mt" :class="{\'form__group--ko\' : !userCheck}">\
                    <label class="form__label" for="user">{{userLabel}}</label>\
                    <div class="form__control-wrapper">\
                        <input class="form__control form-control" v-model="user" type="text" id="user" autocorrect="off" autocapitalize="off">\
                    </div>\
                </div>\
            </div>\
\
            <div class="col-12 col-md-6">\
                <div class="form__group form__group--md-rm-mt" :class="{\'form__group--ko\' : !passwdCheck}">\
                    <label class="form__label" for="passwd">{{passwdLabel}}</label>\
                    <div class="form__control-wrapper">\
                        <input class="form__control form-control" v-model="passwd" type="password" id="passwd">\
                    </div>\
                </div>\
            </div>\
        </div>\
\
        <div class="form__validation form__validation--ko" v-if="errors.length">\
            <p class="form__validation-text" v-for="error in errors">\
                {{error}}\
            </p>\
        </div>\
\
        <div class="form__validation form__validation--ok" v-if="successMessage">\
            <p class="form__validation-text">\
                {{successMessage}}\
            </p>\
        </div>\
\
        <div class="form__group u-mt-xs">\
            <input class="btn" id="btn-send" type="submit" :value="submitLabel" @click.prevent="sendForm">\
        </div>\
\
    </form>',
});